export function initCiciEyes() {
  const orb = document.querySelector('.orb');
  const eyes = document.querySelectorAll('.eye');
  const thinkLinks = document.querySelectorAll('.cici-think');

  if (!orb || eyes.length === 0) return;

  thinkLinks.forEach(link => {
    link.addEventListener('click', () => {
      orb.classList.add('thinking');
      setTimeout(() => {
        orb.classList.remove('thinking');
      }, 3000);
    });
  });

  let targetX = 0;
  let targetY = 0;
  let currentX = 0;
  let currentY = 0;
  const maxMove = 5;
  const ease = 0.1;

  document.addEventListener('mousemove', (e) => {
    const rect = orb.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const deltaX = e.clientX - centerX;
    const deltaY = e.clientY - centerY;

    targetX = Math.max(Math.min(deltaX / 40, maxMove), -maxMove);
    targetY = Math.max(Math.min(deltaY / 40, maxMove), -maxMove);
  });

  function animateEyes() {
    currentX += (targetX - currentX) * ease;
    currentY += (targetY - currentY) * ease;

    eyes.forEach(eye => {
      eye.style.transform = `translate(-50%, -50%) translate(${currentX}px, ${currentY}px)`;
    });

    requestAnimationFrame(animateEyes);
  }

  animateEyes();

  function blinkTogether() {
    eyes.forEach(eye => {
      eye.style.height = 'clamp(2px, 5%, 5px)';
    });

    setTimeout(() => {
      eyes.forEach(eye => {
        eye.style.height = 'clamp(12px, 20%, 40px)';
      });
    }, 150);

    const nextBlink = Math.random() * 4000 + 3000;
    setTimeout(blinkTogether, nextBlink);
  }

  blinkTogether();

  // Set current year
  const yearSpans = document.querySelectorAll('.get-year');
  const currentYear = new Date().getFullYear();
  yearSpans.forEach(span => {
    span.textContent = currentYear;
  });
}